export const TETHER_USDT_GUIDE_PATH = '/tether_usdt_easy_guide.html'
export const TETHER_INQUIRY_BANNER_URL = '/assets/images/tether_inquiry.png'

export function openTetherUsdtGuide () {
  if (typeof window === 'undefined') return
  window.open(TETHER_USDT_GUIDE_PATH, '_blank', 'noopener,noreferrer')
}
